import React, { useState } from "react";
import Loader from "components/loader.tsx";
import { Dialog, Button, Input, Form } from "element-react";

const AcceptButton = ({ row, title, handleSave, status }) => {
  const [state, setState] = useState({ isLoading: false });
  const [isVisible, setVisible] = useState(false);
  const closeModal = () => {
    setVisible(false);
  };
  const onSave = async (e) => {
    var param = { status, articleId: row.Id, remarks: "" };
    await handleSave(param);
    closeModal();
  };
  return (
    <>
      <Button size="mini" onClick={() => setVisible(true)}>
        {title}
      </Button>
      {isVisible && (
        <Dialog
          title="Are you sure, you want to accept this article?"
          visible={isVisible}
          onCancel={closeModal}
          style={{ width: "450px" }}
        >
          <Dialog.Body>
            <Loader isLoading={state.isLoading}>
              <div>
                <span className="margin-bottom-10">
                  By accepting this article, you will able to proceed for
                  further action.
                </span>
                <div className="flex-end">
                  <Button type="primary" onClick={onSave}>
                    Ok
                  </Button>
                </div>
              </div>
            </Loader>
          </Dialog.Body>
        </Dialog>
      )}
    </>
  );
};
export default AcceptButton;
